<template>
    <div  v-resize="onResize">
        <loader v-if="loading" />
        <template v-if="!loading">
            <v-layout row wrap pb-2 align-center>
                <v-flex md8>
                    <h1 v-if="pageHeader">{{ this.header }}</h1>
                    <h2 v-if="!pageHeader">{{ this.header }}</h2>
                    <p v-if="subHeader">{{ this.subHeader }}</p>
                </v-flex>
                <v-flex xs12 md4>
                    <v-text-field :class="{mobileTextField: isMobile}" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    <v-menu v-if="!this.loading && this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                        <v-btn outline small slot="activator">
                            Sort <v-icon>sort</v-icon>
                        </v-btn>
                        <v-list>
                            <v-subheader>Sort by:</v-subheader>
                            <v-list-tile v-for="(item, index) in headers.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                                <v-list-tile-title>
                                    {{ item.text }}
                                    <v-icon v-if="pagination.sortBy === item.value">{{pagination.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-flex>
            </v-layout>
            <v-data-table :items="items"
                    :headers="headers"
                    :search="search"
                    :custom-sort="customSort"
                    :pagination.sync="pagination"
                    :rows-per-page-items="ROWS_LISTITEMS" 
                    :hide-headers="isMobile"
                    :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                    :loading="loading"
                    disable-initial-sort>

                <template v-slot:items="props">
                    <router-link v-if="isMobile" :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Phid }}" class="tr handbook-tablerow_link">
                        <td>
                            <div class="flex-content">
                                <div class="flex-item flex-item-col flex-item-col-30">
                                    <div class="flex-item">
                                        <Portrait v-bind:PHID="props.item.Phid" :fixedWidth="80"></Portrait>
                                    </div>
                                </div>
                                <div class="flex-item flex-item-col flex-item-col-70">
                                    <div class="flex-item">
                                        <h3 class="pb-xs-1">{{ props.item.Number }} - {{ props.item.DisplayName }}</h3>
                                    </div>
                                    <div class="flex-item" data-label="Party">
                                        {{ props.item.Parties.join(", ")}}
                                    </div>
                                    <div class="flex-item flex-item-col flex-item-col-40" data-label="Date Start">{{ props.item.DateStart | stringDateFormat }}</div>
                                    <div class="flex-item flex-item-col flex-item-col-60" data-label="Date End">
                                        <span v-if="props.item.DateEnd != null">{{ props.item.DateEnd | stringDateFormat }}</span>
                                        <span v-if="props.item.DateEnd == null">N/A</span>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </router-link>
                    <router-link v-else :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Phid }}" class="tr handbook-tablerow_link">
                        <td class="text-xs-left">{{ props.item.Number }}</td>
                        <td class="text-xs-left"><Portrait :PHID="props.item.Phid" :fixedWidth="80"></Portrait></td>
                        <td class="text-xs-left">{{ props.item.DisplayName }}</td>
                        <td class="text-xs-left" >
                            {{ props.item.Parties.join(", ")}}
                        </td>
                        <td class="text-xs-left handbook-tablecol_linebreaks">
                            <span class="d-block" v-for="service in props.item.Service" :key="props.item.Phid + '-start-' + service.DateStart">
                               <span v-if="props.item.DateStart != null">{{ service.DateStart | stringDateFormat }}</span>
                               <span v-if="props.item.DateStart == null">N/A</span>
                            </span>
                        </td>
                        <td class="text-xs-left handbook-tablecol_linebreaks">
                            <span class="d-block" v-for="service in props.item.Service" :key="props.item.Phid + '-end-' + service.DateEnd">
                               <span v-if="props.item.DateEnd != null">{{ service.DateEnd | stringDateFormat }}</span>
                               <span v-if="props.item.DateEnd == null">N/A</span>
                            </span>
                        </td>
                    </router-link>
                </template>
            </v-data-table>
            <br />
            <v-layout row wrap>
                <v-flex xs12>
                    <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                        <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                        <span>&nbsp;Download {{header}} as CSV</span>
                    </v-btn>
                </v-flex>
            </v-layout>        
        </template>
    </div>
</template>
<script>
import Loader from '@/components/Loader.vue';
import Portrait from '@/components/Portrait.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    props: ['url', 'header', 'subHeader', 'pageHeader'],
    created() {
        this.initialiseItems();
    },
    components: {
        Loader,
        Portrait
    },
    computed: {
        csvDownloadIcon(){
            return this.csvDownloading ? 'cached' : 'text_snippet';
        },
        csvDownloadClass(){
            let csvClass = 'mr-1';
            if (this.csvDownloading){
                csvClass = csvClass + ' loading'
            }
            return csvClass;
        },
    },
    methods: {
        initialiseItems() {
            this.loading = true;
            axios.get(`api/${this.url}`)
                .then(response => {
                    this.items = response.data;
                    this.loading = false;
                });
        },
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } 
            else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
        },
        customSort(items, index, isDesc) {
            items.sort((a, b) => {
                if (index === 'DateStart' || index == null) {
                    if (!isDesc && index != null) {
                        a.Service = a.Service.sort((c, d) => (c.DateStart > d.DateStart) ? 1 : -1)
                        b.Service = b.Service.sort((c, d) => (c.DateStart > d.DateStart) ? 1 : -1)
                        const aService = a.Service[0].DateStart;
                        const bService = b.Service[0].DateStart;
                        return aService < bService ? -1 : 1;
                    } 
                    else if (index == null) {
                        a.Service = a.Service.sort((c, d) => (c.DateStart > d.DateStart) ? 1 : -1)
                        b.Service = b.Service.sort((c, d) => (c.DateStart > d.DateStart) ? 1 : -1)
                        const aService = a.Service[0].DateStart;
                        const bService = b.Service[0].DateStart;
                        return aService > bService ? -1 : 1;
                    } 
                    else {
                        a.Service = a.Service.sort((c, d) => (c.DateStart < d.DateStart) ? 1 : -1)
                        b.Service = b.Service.sort((c, d) => (c.DateStart < d.DateStart) ? 1 : -1)
                        const aService = a.Service[0].DateStart;
                        const bService = b.Service[0].DateStart;
                        return bService < aService ? -1 : 1;
                    }
                }
                else if (index === 'DateEnd') {
                    if (!isDesc) {
                        a.Service = a.Service.sort((c, d) => (c.DateEnd > d.DateEnd) ? 1 : -1)
                        b.Service = b.Service.sort((c, d) => (c.DateEnd > d.DateEnd) ? 1 : -1)
                        const aService = a.Service[0].DateEnd;
                        const bService = b.Service[0].DateEnd;
                        if (aService == null || aService == '0001-01-01T00:00:00' || aService == '1900-01-01T00:00:00') {
                            return 1;
                        }
                        else if (bService == null || bService == '0001-01-01T00:00:00' || bService == '1900-01-01T00:00:00') {
                            return -1;
                        }
                        return aService < bService ? -1 : 1;
                    } else {
                        a.Service = a.Service.sort((c, d) => (c.DateEnd < d.DateEnd) ? 1 : -1)
                        b.Service = b.Service.sort((c, d) => (c.DateEnd < d.DateEnd) ? 1 : -1)
                        const aService = a.Service[0].DateEnd;
                        const bService = b.Service[0].DateEnd;
                        if (aService == null || aService == '0001-01-01T00:00:00' || aService == '1900-01-01T00:00:00') {
                            return -1;
                        }
                        else if (bService == null || bService == '0001-01-01T00:00:00' || bService == '1900-01-01T00:00:00') {
                            return 1;
                        }
                        return bService < aService ? -1 : 1;
                    }
                }
                else {
                    if (!isDesc) {
                        return a[index] < b[index] ? -1 : 1;
                    } else {
                        return b[index] < a[index] ? -1 : 1;
                    }
                }
            });
            return items;
        },   
        exportCsv: function () {
            this.csvDownloading = true;
            const records = [];

            for (let i = 0; i < this.items.length; i++) {
                const person = this.items[i];
                for (let j = 0; j < person.Service.length; j++) {
                    const service = person.Service[j];

                    records.push({ 
                        Phid: person.Phid,
                        'Name': person.DisplayName,
                        'Party': service.Party,
                        'Start Date': this.formatDate(service.DateStart, '', 'YYYY-MM-DD', false),
                        'End Date': this.formatDate(service.DateEnd, '', 'YYYY-MM-DD', false)
                        });
                }   
            }
             
            let headers = this.headers.map(h => h.text);
            const filename = this.header;
            const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
            this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
        } ,
    },
    mounted() {
        this.onResize();
        //Set page to 10 on mobile, only on mount
        if (this.isMobile){
            this.pagination.rowsPerPage = 10;
        }
    },
    data() {
        return {
            isMobile: false,
            csvDownloading: false,
            headers: [
                {
                    text: 'Number',
                    value: 'Number',
                    align: 'left',
                    sortable: true,
                    width: 1
                },
                {
                    text: '',
                    value: 'Phid',
                    align: 'left',
                    sortable: false,
                    width:'120px'
                },
                {
                    text: 'Name',
                    value: 'DisplayName',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Party',
                    value: 'Party',
                    align: 'left',
                    sortable: false,
                    width:'300px'
                },
                {
                    text: 'Start Date',
                    value: 'DateStart',
                    align: 'left',
                    sortable: true,
                    width:'130px'
                },
                {
                    text: 'End Date',
                    value: 'DateEnd',
                    align: 'left',
                    sortable: true,
                    width:'130px'
                }
            ],
            items: [],
            search: '',
            loading: true,
            ROWS_LISTITEMS: [5, 10, 50, {
                "text": "$vuetify.dataIterator.rowsPerPageAll",
                "value": -1
            }],
            pagination: {
                rowsPerPage: this.$store.state.ROWS_PER_PAGE,
                sortBy: null,
                descending: true
            },
        }
    }
}
</script>
<style scoped>
    a {
        color: #fff;
        text-decoration: none;
    }

    td.handbook-tablecol_linebreaks {
        white-space: pre;
    }

    tr.handbook-tablerow_link {
        cursor: pointer;
    }

    .v-datatable .tr {
        display:table-row;
    }

    .v-datatable a.tr {
        color: #0e1531de;
        text-decoration:none;
        border: 1px solid #dbdbdb;
        border-left: none;
        border-right: none;
    }

    .v-datatable tbody td {
        vertical-align: middle;
    }
</style>